import React from "react";
import { useGlobal } from "reactn";
import ItemTimeline from "components/ItemTimeline";
import SkillPath from "components/common/Skills/SkillPath";
import FullRuneTree from "components/common/RuneTrees/FullRuneTree";

const BuildSection = (props) => {
  const [windowBreakpoint] = useGlobal("responsive");
  const { data, winConditionClass } = props;
  const { historicalData, matchSummary } = (data && data.match) || {};
  const { championId, version } = matchSummary;
  const { itemPath, primaryStyle, runes, skillPath, statShards, subStyle } = historicalData || {};

  return (
    <div className="build-section">
      <div className="section runes-section">
        <div className="content-section_header rune-section-header">Runes</div>
        <div className="build-content">
          <div className="build-content_center">
            <FullRuneTree
              primaryStyle={primaryStyle}
              subStyle={subStyle}
              activePerks={runes}
              activeShards={statShards}
              version={version}
              isMobile={windowBreakpoint === "MOBILE_SMALL" || windowBreakpoint === "MOBILE_MEDIUM"}
            />
          </div>
        </div>
      </div>
      <div className="section skill-section">
        <div className="content-section_header skill-section-header">Skill Order</div>
        <div className="build-content">
          <div className="build-content_center">
            <SkillPath championId={championId} skillOrder={skillPath || []} />
          </div>
        </div>
      </div>
      <div className="section item-path">
        <div className="content-section_header item-section-header">Items</div>
        <div className="build-content">
          <div className="build-content_center">
            <ItemTimeline
              items={itemPath.map((item) => [item.itemId, item.timestamp, item.type])}
              winConditionClass={winConditionClass}
              patch={version}
              spriteSize={30}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildSection;
